import type { Starter } from '../Starter'

export const operationsStarters: Starter[] = [
  {
    id: 'flowchart',
    name: 'Flowchart',
    description: 'Decisions & paths',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    translationKey: 'templates.names.flowchart',
    // The card opens the FlowchartStartPicker (Blank / Basic / Swimlane /
    // BPMN) — no pre-picked seed. The seedId serves the system face.
    artifact: { kind: 'seed', seedId: 'flowchart-basic', diagramType: 'flowchart' },
    pickerOnOpen: true,
    job: ['map-process'],
    function: ['operations'],
    popular: true,
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'swimlane-approval',
    name: 'Swimlane Approval',
    description: 'Cross-team flow',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'swimlane-approval', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'bpmn-order',
    name: 'BPMN Process',
    description: 'Order fulfillment',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'bpmn-order', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'new-hire-onboarding-sop',
    name: 'New-hire Onboarding SOP',
    description: 'HR · IT · Manager lanes',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'new-hire-onboarding-sop', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations', 'people'],
    growsInto: 'process',
    trigger: 'new-hire',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'sipoc',
    name: 'SIPOC',
    description: 'Process scope at a glance',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'sipoc', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'service-blueprint',
    name: 'Service Blueprint',
    description: 'Front & back stage',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'service-blueprint', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'value-stream-map',
    name: 'Value Stream Map',
    description: 'Flow & waste',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'value-stream-map', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'decision-flow',
    name: 'Decision Flow',
    description: 'Branching paths',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'decision-flow', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'standard-operating-procedure',
    name: 'Standard Operating Procedure',
    description: 'Steps · checks · evidence',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'standard-operating-procedure', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'handoff-process',
    name: 'Team Handoff',
    description: 'Context transfer',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'handoff-process', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'bpmn-exception-handling',
    name: 'BPMN Exception Handling',
    description: 'Escalations & decisions',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'bpmn-exception-handling', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'bpmn-pool-collaboration',
    name: 'BPMN Collaboration',
    description: 'Pools, lanes, handoffs',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'bpmn-pool-collaboration', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'customer-journey-process',
    name: 'Journey to Process',
    description: 'Journey stages to work',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'customer-journey-process', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'support-model',
    name: 'Support Model',
    description: 'Tiered service flow',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'support-model', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'bottleneck-map',
    name: 'Bottleneck Map',
    description: 'Queues & constraints',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'bottleneck-map', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'five-whys-root-cause',
    name: '5 Whys Root Cause',
    description: 'Cause to action',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'five-whys-root-cause', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
]
